var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('common-title-panel-vue',{attrs:{"title":_vm.title,"subTitle":_vm.subTitle}}),_c('div',{ref:"chart",style:({ width: '100%', height: _vm.chartHeight + 'vh' })})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }